import doNothing from '@opsbase/lib-general/utils/doNothing';
import { enableTempStorage, getStoredValue, setStoredValue } from '@opsbase/lib-storage';
import useOrgFindById from '@opsbase/react-gql-hooks/organisation/useOrgFindById';
import useTaskFindById from '@opsbase/react-gql-hooks/task/useTaskFindById';
import useParams from '@opsbase/web-nav/useParams';
import React, { useEffect, useMemo, useState } from 'react';
import Dashboard from '../../../../shared/UX/Dashboard/Dashboard';
function useKeyDecoder(uriEncodedKey) {
    return useMemo(() => {
        const key = decodeURIComponent(uriEncodedKey);
        const base64 = key.substring(key.length - 6, key.length) + key.substring(0, key.length - 6);
        const [taskId, token] = Buffer.from(base64, 'base64').toString().split('###');
        if (getStoredValue('accessToken') !== token)
            setStoredValue('accessToken', token);
        return taskId;
    }, [uriEncodedKey]);
}
export function DashboardReportPage() {
    enableTempStorage();
    const { key } = useParams();
    const [state, setState] = useState();
    const taskId = useKeyDecoder(key);
    const { loading, data } = useTaskFindById({ variables: { id: taskId } });
    useEffect(() => {
        if (loading || !data)
            return undefined;
        if (state)
            return;
        const { orgId: organisationId } = data === null || data === void 0 ? void 0 : data.config;
        setState({
            organisationId,
        });
    }, [loading, data, state]);
    if (!state)
        return null;
    return React.createElement(DashboardReportPageInner, { ...state });
}
function DashboardReportPageInner(props) {
    var _a;
    const { organisationId } = props;
    const { data: organisation } = useOrgFindById({
        variables: { id: organisationId },
    });
    if (!organisation)
        return null;
    return (React.createElement(Dashboard, { isEditable: false, dashboardWidgets: (_a = organisation === null || organisation === void 0 ? void 0 : organisation.settings) === null || _a === void 0 ? void 0 : _a.dashboardWidgets, onChange: doNothing, onOpen: doNothing }));
}
export default DashboardReportPage;
